
import objectPath from 'object-path'
import initialState from './initialState'

const mutations = {
  setCollection(state, payload) {
    state.collection = payload
  },
  updateCollection(state, payload) {
    state.collection = [
      ...state.collection,
      ...payload
    ]
  },
  setCollectionFilters(state, payload) {
    state.isFiltersLoaded = true

    state.collectionFilters = {
      ...state.collectionFilters,
      ...payload
    }
  },
  setMinPrices(state, payload) {
    state.minPrices = {
      ...state.minPrices,
      ...payload
    }
  },
  setPlace(state, { slug, type, name }) {
    state.form.placeId = slug
    state.form.placeType = type
    state.form.placeName = name
  },
  updateFavorite(state, { hotelId, favoriteId }) {
    state.collection.find(hotel => hotel.id === hotelId).favoriteId = favoriteId
  },
  clearCurrentLocations(state) {
    state.form.locations = initialState().form.locations
  },
  setField(state, { target, value }) {
    objectPath.set(state, target, value)
  },
  setSearchFieldsFromQueryParams(state, { filters, ...form }) {
    state.filters = {
      ...state.filters,
      ...filters
    }

    Object.keys(form.locations).forEach((key) => {
      form.locations[key] = {
        ...form.locations[key],
        name: form.locations[key].name ? decodeURI(form.locations[key].name) : null
      }
    })

    form.locations = {
      ...initialState().form.locations,
      ...form.locations
    }

    state.form = {
      ...state.form,
      ...form,
      page: 1
    }
  },
  updatePagination(state, payload) {
    state.pagination = {
      ...state.pagination,
      ...payload
    }
  },
  setIsLoading(state, payload) {
    state.isLoading = payload
  },
  setIsUpdating(state, payload) {
    state.isUpdating = payload
  },
  setIsFiltersDisabled(state, payload) {
    state.isFiltersDisabled = payload
  },
  setIsLoadingMore(state, payload) {
    state.isLoadingMore = payload
  },
  setIsEmptySearchResult(state, payload) {
    state.isEmptySearchResult = payload
  },
  updateIsFavoriteLoading(state, payload) {
    state.isFavoriteLoading = payload
  },
  setIsFiltersApplied(state, payload) {
    state.isFiltersApplied = payload
  },
  setInitialState() {
    this.state.hotelsSearch = initialState()
  },
  setErrors(state, errors) {
    state.formErrors = errors
  },
  setFormShowed(state, isShowed) {
    state.showForm = isShowed
  },
  setSearchShowed(state, isShowed) {
    state.showSearch = isShowed
  },
  clearFilters(state) {
    state.isFiltersLoaded = false
    state.filters = initialState().filters
  },
  resetPagination(state) {
    state.pagination = initialState().pagination
  }
}

export default mutations